import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const IMAGE =
  "https://customer-assets-jai6qajn.emergentagent.net/job_mortgage-elite/artifacts/m94r1185__91A7861.jpg";

export const FullBleed = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      ref={ref}
      data-testid="fullbleed-section"
      className="relative h-[60vh] md:h-[80vh] overflow-hidden"
    >
      <motion.img
        src={IMAGE}
        alt="Caitlin Morrison working quietly at her laptop"
        style={{ y, scale: 1.25 }}
        className="absolute inset-0 w-full h-full object-cover"
        data-testid="fullbleed-image"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
      <div className="absolute inset-0 flex items-end">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 w-full pb-14 md:pb-20">
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            data-testid="fullbleed-quote"
            className="font-display italic font-medium text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight text-[#FBF7F2] max-w-3xl text-balance"
          >
            Working quietly in the background, so settlement day feels
            effortless.
          </motion.p>
        </div>
      </div>
    </section>
  );
};
